import { render, staticRenderFns } from "./CustomMatchup.vue?vue&type=template&id=20c9f12c&scoped=true"
import script from "./CustomMatchup.vue?vue&type=script&lang=ts"
export * from "./CustomMatchup.vue?vue&type=script&lang=ts"
import style0 from "./CustomMatchup.vue?vue&type=style&index=0&id=20c9f12c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c9f12c",
  null
  
)

export default component.exports